import React from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

const chartStyle = {
  background: '#fff',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 0 10px rgba(0,0,0,0.05)',
  flex: 1,
};

const labelStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '6px',
  fontSize: '14px'
};

function PieChartBox({ title, labels, series, colors }) {
  const options = {
    chart: {
      type: 'donut'
    },
    labels: labels,
    legend: {
      show: false
    },
    colors: colors,
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 0
    }
  };

  return (
    <div style={chartStyle}>
      <h4>{title}</h4>
      <hr />
      <div style={{ display: 'flex' }}>
        <div style={{ width: '50%' }}>
          <Chart options={options} series={series} type="donut" width="100%" />
        </div>
        <div style={{ width: '50%', paddingLeft: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          {labels.map((label, index) => (
            <div key={index} style={labelStyle}>
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                <span style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: colors[index],
                  display: 'inline-block'
                }}></span>
                {label}
              </div>
              <div>
                {series[index]}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function PieCharts() {
  const { dashboardData } = useSelector((state) => state.dashboard);

  if (!dashboardData || !dashboardData.species && !dashboardData.breeds) {
    return null; // or loading spinner
  }

  const species = dashboardData.species || {};
  const breeds = dashboardData.breeds || {};

  // Species chart
  const speciesLabels = ['Dog', 'Cat', 'Others'];
  const speciesValues = [species.dogs || 0, species.cats || 0, species.others || 0];
  const speciesColors = ['#004f9e', '#9ca9ff', '#dee6ff'];

  const breedEntries = Object.entries(breeds).sort((a, b) => b[1] - a[1]).slice(0, 5); // Top 5 breeds
  const breedLabels = breedEntries.map(([key]) => key);
  const breedSeries = breedEntries.map(([, value]) => value);
  const breedColors = ['#004f9e', '#9ca9ff', '#dee6ff', '#c0d4ff', '#a5bfff']; // 5 colors

  const speciesChart = {
    title: 'Species',
    labels: speciesLabels,
    series: speciesValues,
    colors: speciesColors,
  };

  const breedsChart = {
    title: 'Top Breeds',
    labels: breedLabels,
    series: breedSeries,
    colors: breedColors,
  };

  return (
    <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
      <PieChartBox {...speciesChart} />
      <PieChartBox {...breedsChart} />
    </div>
  );
}